import HeaderForDefaultLogo from "../header/HeaderForDefaultLogo";
import { Grid, Toolbar } from "@mzc-pdc/ui";

const LayoutForDefaultLogo = ({ children }) => {
    return (
        <Grid container flexDirection={"column"} height={1}>
            <Grid item>
                <HeaderForDefaultLogo />
                <Toolbar />
            </Grid>
            <Grid item xs>
                {children}
            </Grid>
        </Grid>
    );
};

export default LayoutForDefaultLogo;
